module.exports = __webpack_public_path__ + "static/media/liveClasses.2fe489bf.svg";